import { Box } from "@mui/material";
import CustomText, { textStyles } from "../CustomText";

const CardTitle = ({ before = "", highlight, after = "", color = "#006EC2" }) => (
  <CustomText
    style={{
      ...textStyles.h5,
      fontWeight: 700,
      fontFamily: "Poppins, sans-serif",
      display: "inline-block",
      position: "relative",
    }}
  >
    {/* ✅ Dot on the left */}
    <Box
      component="span"
      sx={{
        position: "absolute",
        top: "1px",
        left: "-4px",
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor: color,
      }}
    />

    {/* ✅ Full title with highlight underlined */}
    {before}
    <Box
      component="span"
      sx={{
        position: "relative",
        display: "inline-block",
        "&::after": {
          content: '""',
          position: "absolute",
          left: 0,
          bottom: 0,
          width: "100%",
          borderBottom: `2px solid ${color}`,
        },
      }}
    >
      {highlight}
    </Box>
    {after}
  </CustomText>
);

export default CardTitle;



